package com.rainbowclubs.rainbow.data.repositories

import com.rainbowclubs.rainbow.data.models.HomeResponse
import com.rainbowclubs.rainbow.domain.repositories.HomeRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.http.isSuccess

class HomeRepositoryImpl(
    private val httpClient: HttpClient,
) : HomeRepository {
    override suspend fun getHomeData(clubId: String): Result<HomeResponse> {
        return try {
            val response = httpClient.get("/home/$clubId")
            if (response.status.isSuccess()) {
                Result.success(response.body())
            } else {
                Result.failure(Exception(response.status.description))
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
